import React from "react";
import {modalActions} from "../actions/modal.actions";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {networkDeviceActions} from "../actions/network-device.actions";
import {Button, Dropdown} from "react-bootstrap";
const DeviceRestartButton = ({t, id, deviceName, showModal, hideModal, restart, size = '', dropdownItem = false}) => {

    const openConfirmModal = (id) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('reset-pc-msg') + " # "  + deviceName,
            confirmLabel: t('restart-btn'),
            confirmIcon: 'fa-undo',
            classNameBtnConfirm: 'btn-warning',
            dataId: id,
            confirmAction: (id) => {
                restart(id);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };

    const closeModal = () => {
        hideModal()
    };

    return (
        dropdownItem ? (
            <Dropdown.Item onClick={() => openConfirmModal(id)}>
                <i className="fas fa-undo"/> &nbsp; Restart
            </Dropdown.Item>
        ) : (
            <Button variant={"warning"} size={size} onClick={() => openConfirmModal(id)}>
                Restart &nbsp; <i className="fas fa-undo"> </i>
            </Button>
        )
    )
}

const mapDispatchToProps = dispatch => ({
    restart: (id) => dispatch(networkDeviceActions.restart(id)),
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    }
});

export default withNamespaces()(connect(null, mapDispatchToProps)(DeviceRestartButton));
